/*  ============
  Actions for the auth module
  ============

  The actions that are available on the
  auth module.

 */
import Api from "Resources/util/api";
import { router } from "Resources/plugins/vue-router";
import Hasher from 'Resources/encrypt/Hasher';
//import { constant_global } from '../../../config/constants';

import * as types from "./mutation-types";
import store from "../..";

export const boot_hash = ({ commit }) => {
    commit(types.BOOT_HASH);
};

export const hash_id = ({ commit, state }, id) =>
    new Promise((resolve, reject) => {
        resolve(state.hashids.encode(id));
    });

export const check = ({ commit }) => {
    commit(types.CHECK);
};

export const refresh_token_lifetime = ({ commit, state }) => {

    // console.warn("Check Token Lifetime");

    let errorMessage = '';

    let lifetime = Hasher.getItem('token_lifetime', false);

    // lifetime  ကို ယူ
    if(lifetime){

        // expire မဖြစ်သေးရင် refresh လုပ်
        if(!helper.isExpire(lifetime)){

            commit(types.REFRESH_TOKEN_LIFETIME);
            return;
        }

        errorMessage = "အသုံးမပြုချိန် ကြာမြင့်နေပါ၍ ပြန်လည် ဝင်ရောက်ပေးပါ";
    }
    else{
        // set lifetime var 
        commit(types.REFRESH_TOKEN_LIFETIME);
        return;
    }
    
    helper.flashErrorMessage(errorMessage);
    // logout ထွက်
    commit(types.LOGOUT);
};

export const fresh_account = ({ commit }) => {
    if (store.state.auth.authenticated) {
        return new Promise((resolve, reject) => {
            Api.puller("/api/active_account")
                .then((response) => {
                    commit(types.FRESH, response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
};

export const login = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        Api.poster("/api/login", payload)
            .then(response => {
                resolve(response.data);
                commit(types.LOGIN, response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const logout = ({ commit }) => {
    commit(types.LOGOUT);
    router.push({
        name: "login",
    });
};

export default {
    check,
    login,
    logout,
    boot_hash,
    hash_id,
    fresh_account,
    refresh_token_lifetime
};
